import {Box, Grid, Button} from "theme-ui";
import {Menu} from "@styled-icons/heroicons-solid/Menu";
import React from "react";
import {getToken, saveToken} from "../../../Utils/loginUtil";
import { useHistory } from 'react-router-dom';

function SiteNavigation() {
    const history = useHistory();
    const token = getToken();

    const logOut = () => {
        saveToken(null);
        history.push("/");
        location.reload();
    };

    return (
        <Grid variant="header">
            <Box variant="header.hamburger">
                {/*<Menu width={28}/>*/}
            </Box>
            <Box variant="header.logo">
                {/*<Box bg="muted" py={3} px={5}/>*/}
            </Box>
            <Box variant="header.notifications" />
            <Box variant="header.profile">
                {/*<Box bg="muted" py={3} px={3} width="45px" />*/}
            </Box>
            <Box variant="header.profile">
                {/*<Box bg="muted" py={3} px={3} width="45px" />*/}
            </Box>
            <Box variant="header.dropdown">
                {/*<Box bg="muted" py={3} px={3} width="45px" />*/}
                {token && <Button variant="primary" onClick={logOut}>Logout</Button>}
            </Box>
        </Grid>);
}

export default SiteNavigation